import { Container as PersonaPickerContainer } from '@sdk/components/forms/personaPickers/PersonaPicker/personaPicker.styles';
import { PersonaPickerInput } from '@sdk/components/forms/personaPickers/PersonaPickerInput/PersonaPickerInput';
import { UserPickerItem } from '@sdk/components/forms/personaPickers/GroupedPersonaPicker/UserPickerItem/UserPickerItem';
import { UserPickerOption } from 'sling-sdk/src/components/forms/personaPickers/PersonaPicker/personaPicker.types';
import { User } from 'sling-sdk/src/users/types/User';
import { usePersonaCollection } from 'sling-sdk/src/personaCollection/PersonaCollectionContext';

import EmptySearchResults from '@web/assets/svg/Misc/empty-search-results.svg';

import {
  ScrollableContainer,
  UserList,
  UserListItem,
  EmptySearchResultsWrapper,
  EmptySearchMessage,
} from './userSearchPicker.styles';

type Props = {
  placeholder: string;
  options: UserPickerOption[];
  searchQuery: string;
  setSearchQuery: (value: string) => void;
  onSelect: (userId: number) => void;
};

export const UserSearchPicker = ({
  placeholder,
  options,
  searchQuery,
  setSearchQuery,
  onSelect,
}: Props) => {
  const { personasDict } = usePersonaCollection();
  const getUserById = (userId: number) => personasDict[userId] as User;
  const hasResults = options.length > 0;

  return (
    <>
      <PersonaPickerContainer disabled={false} hasError={false}>
        <PersonaPickerInput
          placeholder={placeholder}
          onChange={(event) => {
            setSearchQuery(event.currentTarget.value);
          }}
          value={searchQuery}
          showIcon={true}
          disabled={false}
        />
      </PersonaPickerContainer>

      {hasResults ? (
        <ScrollableContainer>
          <UserList>
            {options.map((option) => (
              <UserListItem key={option.id} onClick={() => onSelect(option.id)}>
                <UserPickerItem item={option} user={getUserById(option.id)} />
              </UserListItem>
            ))}
          </UserList>
        </ScrollableContainer>
      ) : (
        <EmptySearchResultsWrapper>
          <EmptySearchResults />
          <EmptySearchMessage>
            <div>No employees!</div>
            <div>Try modifying your search or checking for typos.</div>
          </EmptySearchMessage>
        </EmptySearchResultsWrapper>
      )}
    </>
  );
};
